module.exports = __webpack_public_path__ + "img/argus_thumb.2d7d250a.jpg";